import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { BuildingTypesEnum } from "dash-common";
import { FiChevronDown } from "react-icons/fi";

import { SearchBarFiltersProps } from "../../constants/constants";
import CustomMultiSelect from "./custom-multi-select";
import {
  capitalizeWords,
  handleGoToFirstPage,
} from "../../helpers/idx-common-helpers";

export const BuildingTypeFilter = ({
  filters,
  mainColor,
  mainColorLight,
  textColor,
  isMobile = false,
  setFilters,
  goToFirstPage,
}: SearchBarFiltersProps) => {
  async function addTypeFilter(type: BuildingTypesEnum) {
    setFilters((draft) => {
      const index = draft.buildingTypes.findIndex((item) => item === type);
      if (index === -1) {
        draft.buildingTypes.push(type);
        return;
      }
      draft.buildingTypes.splice(index, 1);
    });
    handleGoToFirstPage(isMobile, goToFirstPage);
  }

  // Converts strings back to enum values
  const handleMobileSelectChange = (values: string[]) => {
    setFilters((draft) => {
      draft.buildingTypes = values.map(
        (value) => BuildingTypesEnum[value as keyof typeof BuildingTypesEnum]
      );
    });
  };

  const getMobileSelectOptions = () => {
    return Object.values(BuildingTypesEnum).map((type) => ({
      value: type,
      label: capitalizeWords(type),
    }));
  };

  return isMobile ? (
    <>
      <CustomMultiSelect
        className="w-full"
        value={filters.buildingTypes}
        options={getMobileSelectOptions()}
        placeholder="Select type"
        onChange={handleMobileSelectChange}
        isSearchable={false}
      />
    </>
  ) : (
    <Popover>
      <PopoverButton
        style={{
          backgroundColor: !!filters.buildingTypes.length
            ? mainColor
            : mainColorLight,
          color: !!filters.buildingTypes.length ? "white" : mainColor,
        }}
        className={`text-sm flex gap-2 items-center rounded-full py-2 px-4 hover:brightness-75`}
      >
        <span>
          Type{" "}
          {!!filters.buildingTypes.length &&
            `(${filters.buildingTypes.length})`}
        </span>
        <FiChevronDown />
      </PopoverButton>
      <PopoverPanel
        anchor="bottom end"
        className="bg-white drop-shadow-lg border rounded-lg mt-1"
        style={{ color: textColor }}
      >
        {Object.values(BuildingTypesEnum).map((type, index) => (
          <button
            className="flex items-center gap-2 px-6 py-2 w-full hover:font-bold"
            onClick={() => addTypeFilter(type)}
            key={index}
          >
            <input
              type="checkbox"
              id={type.toString()}
              checked={!!filters.buildingTypes.find((item) => item === type)}
              readOnly
            />
            <span className="capitalize text-slate-700">
              {type.toLowerCase().split("_").join(" ")}
            </span>
          </button>
        ))}
      </PopoverPanel>
    </Popover>
  );
};
